import {Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from "rxjs/index";
import { FileUploader } from 'ng2-file-upload';
import { Router } from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CsToastBoxService} from "@app/services";
import {DomSanitizer} from "@angular/platform-browser";
import {ViewVehicleService} from "@app/features/fleet-management/add-vehicle/services/view-vehicle-service";
import {JobViewService} from "@app/features/customers/customer/jobs-view/service/job-view-service"
import {GetSelect2FileTagsOptions} from "@app/utils";
import {TABLETYPES} from "@app/config";
import {HttpClient} from "@angular/common/http";
import {GetJobApiUrl} from "@app/utils/get-job-api-url";
import {AuthService} from "@app/core";
import {PropertyViewService} from "@app/features/customers/customer/property-view/service/property-view.service";

declare var $: any;

@Component({
  selector: 'app-file-add-edit',
  templateUrl: './file-edit.component.html',
  styleUrls: ['./file-edit.component.scss']
})
export class FileEditComponent implements OnInit, AfterViewInit {
    public onClose: Subject<boolean>;
    data: any;
    attachedFileEditForm: FormGroup;
    fileLocation: any;
    action: string = 'save';
    fileNames : any;
    fileExtension: string = '';
    imageView:boolean = false;
    screen: string= '';
    showFile: boolean = true;
    showTagDropDown: boolean = false;
    tagsSelect2Config: any;
    selectedTags = [];
    isTagUpdated: boolean= false;

    shareOnMobile: boolean = false;
    showShareOnMobile: boolean = false;
    showCustomerPortal: boolean = false;
    shareOnPortal : boolean = false
    customerPortalVisibilityStatus : any = "hide"

    @ViewChild('select2EditFileTags') select2FileTags: ElementRef;

    constructor(
        private formBuilder: FormBuilder,
        private viewVehicleService: ViewVehicleService,
        public bsModalRef: BsModalRef,
        private toastBoxService: CsToastBoxService,
        private sanitizer: DomSanitizer,
        private jobViewService: JobViewService,
        private http: HttpClient,
        private authService: AuthService,
        private propertyViewService: PropertyViewService,
    ) { }

    ngOnInit() {
        this.shareOnMobile = this.data['imageData'].shareOnMobile;
        // this.showCustomerPortal = Boolean(this.data['imageData'].customerPortalAccess);
        this.showCustomerPortal = this.data['imageData'].customerPortalAccess;
        this.customerPortalVisibilityStatus = this.data['imageData'].customerPortalVisibilityStatus || 'hide'
        // this.showCustomerPortal = true;
        this.shareOnPortal = Boolean(this.data['imageData'].shareOnPortal);
        this.onClose = new Subject();
        this.imageView = false;
        const { baseName, extension } = this.getFileNameParts(
            this.data['imageData'].name,
            this.data['imageData'].filetype,
        );
        this.fileNames = this.data['imageData'].name;
        this.fileExtension = extension;
        this.screen = (this.data['screen']) ? this.data['screen'] : '';
        this.showFile =  (this.data['showFile'] !== undefined && this.data['showFile'] !== null)
            ? this.data['showFile']
            : true;
        this.showTagDropDown = (this.data['showTagDropDown'] !== undefined && this.data['showTagDropDown'] !== null)
            ? this.data['showTagDropDown']
            : false;
        if(this.showTagDropDown) {
            this.tagsSelect2Config = GetSelect2FileTagsOptions();
        }

        if(this.data['modalType'] == 'edit'){
            this.buildAttachedFilesForm(this.data); //form initalizes
            if(this.data['imageData'].filetype == 'PDF' || this.data['imageData'].filetype == 'pdf'){
                this.fileLocation = this.sanitizer.bypassSecurityTrustResourceUrl(this.data['imageData'].location);
            }else{
                this.fileLocation = this.data['imageData'].location; //get image path and store imgloation variable
            }
        }else{
            if(this.data['imageData'].filetype == 'PDF' || this.data['imageData'].filetype == 'pdf'){
                this.fileLocation = this.sanitizer.bypassSecurityTrustResourceUrl(this.data['imageData'].location);
            }else{
                this.fileLocation = this.data['imageData'].location; //get image path and store imgloation variable
                this.imageView = true;
            }
        }
    }

    ngAfterViewInit () {
        const setUpfileTagsReadAccess = this.authService.permitted(['SetupFileTags.readaccess']) === true;
        if (this.showTagDropDown && setUpfileTagsReadAccess) {
            if (this.data['imageData'].hasOwnProperty('selectedFileTag') && this.data['imageData'].selectedFileTag.length) {
                this.tagsSelect2Config['data'] = this.data['imageData'].selectedFileTag;
                $(this.select2FileTags.nativeElement).select2('data', this.data['imageData'].selectedFileTag);
            }
        }
    }

    // build attached files form
    buildAttachedFilesForm(data) {
        const { baseName } = this.getFileNameParts(
            data['imageData'].name,
            data['imageData'].filetype,
        );
        this.attachedFileEditForm = this.formBuilder.group({
            'id': [data['imageData'].id],
            'fileName': [baseName, [Validators.required, this.noWhitespaceValidator]],
            'shareOnMobile': [data['imageData'].shareOnMobile || false],
            'shareOnPortal': [{
                value: Boolean(data['imageData'].shareOnPortal),
                disabled: data['imageData'].createdByPortal || this.customerPortalVisibilityStatus === 'disable'
            }]
        });
    }

    save() {
        if (!this.attachedFileEditForm || this.attachedFileEditForm.invalid) {
            this.attachedFileEditForm.get('fileName').markAsTouched();
            return;
        }

        this.action = 'saving';

        const id = this.attachedFileEditForm.value.id;
        const updatedFileName = this.getUpdatedFileName(this.attachedFileEditForm.value.fileName);

        if (!updatedFileName || updatedFileName === this.fileExtension) {
            this.attachedFileEditForm.get('fileName').setErrors({ whitespace: true });
            this.attachedFileEditForm.get('fileName').markAsTouched();
            this.action = 'save';
            return;
        }

        const data = {
            fileName: updatedFileName,
            id: id,
            shareOnMobile: this.attachedFileEditForm.value.shareOnMobile,
            shareOnPortal : this.attachedFileEditForm.getRawValue().shareOnPortal
        };

        const renameData = {
            fileId: id,
            fileType: this.data['imageData'].filetype,
            name: (this.attachedFileEditForm.value.fileName || '').trim(),
        };

        const updateFile$ = this.screen === 'jobFiles'
            ? this.jobViewService.updateFile(id, data)
            : this.propertyViewService.renameFiles(renameData);

        // Call main save API
        updateFile$.subscribe({
            next: () => {
                this.fileNames = updatedFileName;
                // After file save success, check and update tags
                if (this.isTagUpdated) {
                    const tagPayload = {
                        tags: this.selectedTags,
                        tableType: TABLETYPES.ATTACHED_FILES,
                        fileId: id
                    };

                    this.http.post(
                        GetJobApiUrl('e5ec7051/addEditFileTags'),
                        tagPayload
                    ).subscribe({
                        next: () => {
                            this.onClose.next(true);
                            this.bsModalRef.hide();
                            this.action = '';
                        },
                        error: (err) => {
                            console.error('Error saving tags:', err);
                            this.action = '';
                        }
                    });
                } else {
                    // If no tag update needed, just close
                    this.onClose.next(true);
                    this.bsModalRef.hide();
                    this.action = '';
                }
            },
            error: (error) => {
                console.error('Error saving file:', error);
                this.action = '';
            }
        });
    }


    async attachFileDownload(imageSrc) {
        const image = await fetch(imageSrc);
        const imageBlog = await image.blob();
        const imageURL = URL.createObjectURL(imageBlog);
        const link = document.createElement('a');
        link.href = imageURL;
        link.download = this.fileNames;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    onCloseModal(){
        setTimeout(() => {
            this.bsModalRef.hide()
        },100)
    }
    ngOnDestroy(){
        $('body').addClass("modal-open")
    }

    selectedTag(tag) {
        this.selectedTags = tag;
        this.isTagUpdated = true;
    }

    private getFileNameParts(fileName: string, fileType?: string): { baseName: string; extension: string } {
        const normalizedExtension = this.normalizeExtension(fileType);

        if (!fileName) {
            return { baseName: '', extension: normalizedExtension };
        }

        const lastDotIndex = fileName.lastIndexOf('.');
        if (lastDotIndex <= 0) {
            return { baseName: fileName, extension: normalizedExtension };
        }

        return {
            baseName: fileName.substring(0, lastDotIndex),
            extension: fileName.substring(lastDotIndex),
        };
    }

    private normalizeExtension(fileType?: string): string {
        const trimmedFileType = (fileType || '').trim();
        if (!trimmedFileType) {
            return '';
        }
        return trimmedFileType.startsWith('.')
            ? trimmedFileType
            : `.${trimmedFileType}`;
    }

    private getUpdatedFileName(fileName: string): string {
        const trimmedFileName = (fileName || '').trim();

        if (!trimmedFileName) {
            return this.fileExtension;
        }

        if (!this.fileExtension) {
            return trimmedFileName;
        }

        return trimmedFileName.endsWith(this.fileExtension)
            ? trimmedFileName
            : `${trimmedFileName}${this.fileExtension}`;
    }

    private noWhitespaceValidator(control: AbstractControl): { whitespace: boolean } | null {
        const value = (control.value || '').trim();
        return value ? null : { whitespace: true };
    }

}
